import {
    Col, Row, Container,
} from 'react-bootstrap';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import useHtmlTitle from '../../../components/Utilities/useHtmlTitle';
import useBodyClass from '../../../components/Utilities/useBodyClass';
import useAccountContext from '../../../authentication/hooks';
import HeaderIntroText from '../../../components/HeaderIntroText';
import FormBanner from '../../../components/forms/FormBanner';

const RequestForQuoteCreated = () => {
    const account = useAccountContext();
    const { id } = useParams();

    useHtmlTitle('Request for quote created successfully | NMI Services portal');
    useBodyClass('account-created');

    const subTitle: string = account?.details?.branch !== undefined && account?.details?.branch !== '' ? `${account?.details?.organisation} - ${account?.details?.branch}` : `${account?.details?.organisation}`;

    return (
        <>
            <FormBanner
                title='Testing and calibration service - Request quote'
                showSaveAndExitButton={false}
                refTitle={`Ref ID: ${id}`}
                subTitle={subTitle}
                showGoToDashboardButton
            />
            <Container fluid id='main' role='main' className='px-0' tabIndex={-1}>
                <Container className='py-5'>
                    <Row className='mb-5'>
                        <Col sm={12} md={10} lg={8} className='mx-auto'>
                            <h1 id='page-title' tabIndex={-1}>
                                Your request has been submitted
                            </h1>
                            <HeaderIntroText>
                                We have received your request for Testing and Calibration services and will review it shortly.
                                If we need additional information, we will reach out to the contact person listed in your request.
                            </HeaderIntroText>
                            <p>
                                When a quotation offer to perform Testing and Calibration services is available,
                                we will notify the contact person provided and the quotation can be progressed through this portal.
                            </p>
                            <div className='d-grid d-md-block'>
                                <Link
                                    data-testid='go-to-dashboard-button'
                                    to='/dashboard'
                                    className='btn btn-primary'
                                >
                                    Go to dashboard
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </>
    );
};

export default RequestForQuoteCreated;
